import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import store from '../flux/store';
import loadingPage from '../pages/loading';
import constructionPage from '../pages/construction';
import { useAlert } from "react-alert";
import { addHistory } from '../flux/actions/historyActions';

const RouteWrapper = ({
  component: Component,
  exact = false,
  loginNotNeeded = false,
  isUnderConstruction = false,
  privilege = -1,
  atLeastOnePrivilege,
  auth = {},
  path,
  // ...rest
}) => {
  // useEffect(() => {
  //   if(path)
  //     addHistory(path, localStorage.getItem('tokenId')).then(e => {})
  // }, [path])
  
  useEffect(() => {
    addHistory(window.location.pathname, localStorage.getItem('tokenId')).then(() => {})
  }, [window.location.pathname])

  const signed = localStorage.getItem('token');
  const [loading, setLoading] = useState(true);
  const isFirstRun = useRef(true);
  
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    
    if(!auth || (auth && auth.loading)){
      setLoading(true);
    }
    else{
      if(!auth.user){
        if(!loginNotNeeded){
          window.location.href = "/connexion/" + encodeURIComponent(window.location.href);
          return
        }
      }
      else if(atLeastOnePrivilege?.length ? atLeastOnePrivilege.filter(e => auth.user.privileges.includes(e)).length === 0 : (privilege > -1 && !auth.user.privileges.includes(privilege))){
        window.location.href = "/connexion";
        return
      }
      setLoading(false);
    }
  }, [auth, window.location.href]);

  const alert = useAlert();
  useEffect(() => alert && alert.removeAll && typeof alert.removeAll === "function" && alert.removeAll(), [window?.location?.pathname]);

  if (!loginNotNeeded && !signed) {
    console.log("NULL GO TO LOGIN")
  }
  // if(auth?.user?.id === 76)
  //   return <Route component={<div>k</div>} />
  return <Route /*{...rest}*/path={path} component={isUnderConstruction && process.env.REACT_APP_NODE_ENV === "production" ? constructionPage : loading ? loadingPage : Component} exact={exact} />;
}

RouteWrapper.propTypes = {
  exact: PropTypes.bool,
  loginNotNeeded: PropTypes.bool,
  isUnderConstruction: PropTypes.bool,
  privilege: PropTypes.number,
  atLeastOnePrivilege: PropTypes.array,
  name: PropTypes.string,
  path: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
};

RouteWrapper.defaultProps = {
  loginNotNeeded: false,
  name: "",
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, null)(RouteWrapper);